<template>

  <div class="booking booking-overview" :class="{expanded: expanded}" v-if="data.listing">
    <div class="inner">

      <div class="booking-header">
        <h4 class="font-md wt-md">
          {{ data.listing.space_name }}
        </h4>
        <h5 class="wt-std fg-primary">
          <!--          <span v-if="data.listing.address_label">{{ data.listing.locality }}, </span>{{ data.listing.region }}-->
          {{ data.listing.address_label }}
        </h5>
      </div>
      <!-- /.booking-header -->

      <div class="booking-actions" v-if="!data.is_expired">
        <!-- <div class="action" v-if="data.actions.on_hold">
          <a class="button muted md place-on-hold" title="Place on hold" @click="openPlaceOnHoldModal">
            <svg-icon id="pause"></svg-icon>
            <span>Place on hold</span>
          </a>
        </div> -->
        <!-- <div class="action" v-if="data.actions.resume">
          <a class="button primary-bright md place-on-hold" title="Resume" @click="openResumeModal">
            <svg-icon id="resume"></svg-icon>
            <span>Resume</span>
          </a>
        </div> -->
        <div class="action" v-if="data.actions.cancel">
          <a class="button muted md place-on-hold" title="Cancel" @click="openCancelModal">
            <svg-icon id="delete"></svg-icon>
            <span>Cancel</span>
          </a>
        </div>
      </div>
      <!-- /.booking-actions -->

      <div class="summary-items">
        <!-- <div class="item">
          <div class="label">Property listing ID</div>
          <div class="value fg-primary">{{ data.listing.id }}</div>
        </div> -->
        <!--        <div class="item" v-if="data.production">-->
        <!--          <div class="label">Production</div>-->
        <!--          <div class="value">{{ data.production.name }}</div>-->
        <!--        </div>-->
        <!--        <div class="item" v-if="data.production">-->
        <!--          <div class="label">Client's Name</div>-->
        <!--          <div class="value">{{ data.production.client_name }}</div>-->
        <!--        </div>-->
        <!-- <div class="item">
          <div class="label">{{ data.booking_type_label }} ID</div>
          <div class="value fg-primary">{{ data.id }}</div>
        </div> -->
        <div class="item" v-if="data.current_quote_total_formatted && isLister">
          <div class="label">Payment to You</div>
          <div class="value fg-primary">{{ data.current_quote_total_formatted }}</div>
        </div>

        <div class="item" v-if="data.sub_total_formatted  && isHirer" >
          <div class="label">Current quote</div>
          <div class="value fg-primary">{{ data.sub_total_formatted }}</div>
        </div>
        <div class="item">
          <div class="label">{{ data.type === 'recce' ? 'Recce' : 'Production' }} Date</div>
          <div class="value fg-primary-dark" v-if="data.from !== data.to">{{ formatDate(data.from, 'D MMM YYYY') }} -
            {{ formatDate(data.to, 'D MMM YYYY') }}
          </div>
          <div class="value fg-primary-dark" v-else>{{ formatDate(data.from, 'D MMM YYYY') }}</div>
        </div>
        <div class="item" v-if="data.type === 'recce' && data.call_times_arrivals.length">
          <div class="label">Time</div>
          <div class="value fg-primary-dark">
            {{ formatTime(data.call_times_arrivals[0], 'h:mma') }}
          </div>
        </div>
        <!--        <div class="item" v-if="data.production">-->
        <!--          <div class="label">Production Type</div>-->
        <!--          <div class="value">{{ shootTypes }}</div>-->
        <!--        </div>-->
      </div>
      <!-- /.summary-items -->

      <table class="resource-table booking-update-listing mobile-hidden">
        <thead>
          <tr>
            <th></th>
            <th>Status</th>
            <th class="task">Details</th>
            <!-- <th class="date">Received At</th> -->
            <th class="item-action">Action</th>
            <!--            <th class="actions">&nbsp;</th>-->
          </tr>
        </thead>
        <tbody>
          <tr
              v-for="(status, index) in data.status_log"
              :class="[status.name, {'active': index === 0}]"
              v-if="data.status_log && data.status_log.length"
          >
            <td class="item-status">
              <span class="dot success" v-if="index === 0"></span>
            </td>
            <td class="name">{{ status.label }}</td>
            <td class="task">{{ status.reason }}</td>
            <!-- <td class="date">{{ status.date }}</td> -->
            <td class="item-action">
              <div>
                <template
                    v-if="status.pending_action && status.pending_action.actions && status.pending_action.actions.length">
                  <a
                      v-for="option in status.pending_action.actions"
                      class="badge block interactive"
                      :class="[option.class]"
                      @click="doAction(option.action)"
                  >
                    {{ option.label }}
                  </a>
                </template>
                <span v-else-if="status.pending_action">
                  {{ status.pending_action.label }}
                </span>
              </div>
            </td>
            <!--            <td class="actions">-->
            <!--              <div class="action-list">-->
            <!--                <div class="action" v-for="(meta, action) in status.actions">-->
            <!--                  <button type="button" class="icon" :class="[action]" @click="doUpdateAction(update, action)">-->
            <!--                    <svg-icon :id="action"></svg-icon>-->
            <!--                  </button>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </td>-->
          </tr>
          <tr class="no-results" v-else>
            <td colspan="5" class="align-center">There are no updates to show here at this time.</td>
          </tr>
        </tbody>
      </table>
      <!-- /.resource-table -->

      <table class="resource-table booking-update-listing mobile-table mobile-visible"
             v-if="data.status_log && data.status_log.length">
        <tbody>
          <template v-for="status in data.status_log">
            <tr class="entry-break danger">
              <th>Status</th>
              <td>{{ status.label }}</td>
            </tr>
            <tr>
              <th>Details</th>
              <td>{{ status.reason }}</td>
            </tr>
            <tr>
              <th>Received At</th>
              <td>{{ status.date }}</td>
            </tr>
            <tr>
              <th>Action</th>
              <td class="item-action">
                <div>
                  <template
                      v-if="status.pending_action && status.pending_action.actions && status.pending_action.actions.length">
                    <a
                        v-for="option in status.pending_action.actions"
                        class="badge block interactive"
                        :class="[option.class]"
                        @click="doAction(option.action)"
                    >
                      {{ option.label }}
                    </a>
                  </template>
                  <span v-else-if="status.pending_action">
                  {{ status.pending_action.label }}
                </span>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <!-- /.resource-table -->

      <div class="toggle-details">
        <span class="toggle-link" @click="expanded = !expanded"><span>See property details</span>
          <svg-icon id="chevronDown"></svg-icon>
        </span>
      </div>
      <!-- /.toggle-details -->

      <div class="more-details-container">

        <div class="inner">

          <div class="property-details">
            <div class="images">
              <ul class="listing property-images" data-featherlight-gallery="image" data-featherlight-filter="a"
                  v-featherlight-gallery="{filter: 'a'}">
                <li v-for="media in data.listing.media">
                  <a :href="media.urls.full" class="interactive tinted tinted-hover tinted-hover-only">
                    <img :src="media.urls.thumbnail_large" :alt="media.name" class="cover">
                  </a>
                </li>
              </ul>
            </div>
            <div class="description">
              <div class="formatted">
                <h6 v-if="data.listing.space_name">
                  {{ data.listing.space_name }}
                </h6>
                <div class="content" v-if="data.is_paid && data.booking_schedule_url"><strong>Address: {{data.listing.address.full_label}}</strong></div>
                <div class="content" v-html="data.listing.description"></div>
                <div class="cta">
                  <a :href="data.listing.slug" class="uc wt-std" target="_blank">View property listing</a>
                </div>
              </div>
            </div>
          </div>
          <!-- /.property-details -->

          <!--          <div class="property-managers" v-if="data.property.managers">-->
          <!--            <h6 class="wt-std font-mdish"-->
          <!--                v-text="'Location manager' + ((data.property.managers.length > 1) ? 's' : '')"></h6>-->

          <!--            <ul class="listing location-managers">-->
          <!--              <li v-for="manager in data.property.managers">-->
          <!--                <div class="image">-->
          <!--                  <img :src="manager.image" class="cover"/>-->
          <!--                </div>-->
          <!--                <div class="detail">-->
          <!--                  <div class="inner">-->
          <!--                    <h6 class="fg-primary">{{ manager.name }}</h6>-->

          <!--                    <div class="content formatted">-->
          <!--                      <p>We are ready to help you with any questions, either message me or call direct</p>-->

          <!--                      <div class="phone">-->
          <!--                        <a :href="'tel:' + manager.phone.replace(/[^0-9]/, '')">{{ manager.phone }}</a>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                    <div class="message">-->
          <!--                      <a href="#" class="button primary">Message Me</a>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </div>-->
          <!-- /.property-managers -->

        </div>

      </div>
      <!-- /.more-details-container -->

    </div>
    <!-- /.inner -->
  </div>

</template>

<script>
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      expanded: false,
    }
  },
  computed: {
    isHirer () {
            return this.$store.getters['user/isHirer']
    },
    isLister () {
        return this.$store.getters['user/isLister']
    },
    shootTypes () {
      let label = ''

      if (this.data.production) {
        let types = this.data.production.types

        if (types.length >= 2) {
          label = types.slice(0, types.length - 1).join(', ')
          label += ' & ' + types[types.length - 1]
        } else {
          label = types[0]
        }
      }

      return label
    },
    fullBookingName () {
      return `${this.data.booking_type_label} <span class="fg-primary">${this.data.listing.space_name}</span>`
    }

  },
  methods: {
    doAction (action) {

      switch (action) {

        case 'review_and_pay':
        const title = this.data.is_payable && this.data.has_cost ? 'Review &amp; Pay' : 'Review'
          this.$store.dispatch('modals/show', {
            title: `${this.fullBookingName} - ${title}`,
            type: 'booking-quote-review',
            data: this.data
          })
              .then(() => {})
              .catch(() => {})
        break

        case 'pay':
          const payTitle = this.data.is_payable && this.data.has_cost ? 'Pay' : 'Review'
          this.$store.dispatch('modals/show', {
            title: `${this.fullBookingName} - ${payTitle}`,
            type: 'hirer-quote-pay',
            data: this.data
          })
              .then(() => {})
              .catch(() => {})
        break

        case 'review':
        const reviewTitle = this.data.is_payable && this.data.has_cost ? 'Review &amp; Pay' : 'Contact Admin'
          this.$store.dispatch('modals/show', {
            title: `${this.fullBookingName} - ${reviewTitle}`,
            type: 'hirer-quote-confirm',
            data: this.data
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'view_quote':
          this.$store.dispatch('modals/show', {
            title: `${this.fullBookingName} - Payout`,
            type: 'booking-lister-quote',
            data: this.data
          })
              .then(() => {})
              .catch(() => {})
        break

        case 'view_detailed_quote':
          this.$store.dispatch('modals/show', {
            title: `${this.fullBookingName} - Quote`,
            type: 'booking-hirer-quote-view',
            data: this.data
          })
              .then(() => {})
              .catch(() => {})
        break
        case 'feedback':
          this.$store.dispatch('modals/show', {
            title: `Amend Booking for ${this.fullBookingName}`,
            type: 'booking-feedback',
            data: this.data
          })
              .then(() => {})
              .catch(() => {})
          break

        case 'confirm':

          if (!this.$store.getters['user/stripeConnectIsOnboarded']) 
          {

              this.$store.dispatch('modals/show', {
              title: `Let's setup your payment details!`,
              type: 'first-payment-setup',
              data: this.data
            })
              .then(() => {})
              .catch(() => {})
            break


          }

          this.$store.dispatch('modals/show', {
            title: `Confirm ${this.fullBookingName}`,
            type: 'booking-confirm',
            data: this.data
          })
              .then(() => {})
              .catch(() => {})
          break

          case 'approve_by_lister':
          if (!this.$store.getters['user/stripeConnectIsOnboarded']) 
          {

              this.$store.dispatch('modals/show', {
              title: `Let's setup your payment details!`,
              type: 'first-payment-setup',
              data: this.data
            })
              .then(() => {})
              .catch(() => {})
            break


          }
            this.$store.dispatch('modals/show', {
              title: `Confirm ${this.fullBookingName}`,
              type: 'lister-quote-confirm',
              data: this.data
            })
              .then(() => {})
              .catch(() => {})
          break

        case 'decline':
          this.$store.dispatch('modals/show', {
            title: `Decline ${this.fullBookingName}`,
            type: 'booking-decline',
            data: this.data
          })
              .then(() => {})
              .catch(() => {})
          break

        case 'download_schedule':
          if (!this.data.booking_schedule_url) {
            return this.$store.dispatch('modals/show', {
              title: `${this.data.booking_type_label} schedule & location`,
              type: 'booking-schedule-unavailable',
              data: this.data
            })
                .then(() => {})
                .catch(() => {})
          }
          window.location.href = `${this.data.booking_schedule_url}?token=${this.$store.getters['user/accessToken']}`
          break
      }
    },
    openPlaceOnHoldModal () {
      this.$store.dispatch('modals/show', {
        title: `Are you sure you want to place ${this.fullBookingName} on hold?`,
        type: 'booking-place-on-hold',
        data: this.data
      })
          .then(() => {})
          .catch(() => {})
    },
    openResumeModal () {
      this.$store.dispatch('modals/show', {
        title: `Resume ${this.data.booking_type_label}?`,
        type: 'booking-resume',
        data: this.data
      })
          .then(() => {})
          .catch(() => {})
    },
    openCancelModal () {
      this.$store.dispatch('modals/show', {
        title: `Are you sure you want to cancel ${this.fullBookingName}?`,
        type: 'booking-cancel',
        data: this.data
      })
          .then(() => {})
          .catch(() => {})
    },
    formatDate (src, format) {
      return dayjs(src).format(format)
    },
    formatTime (src, format) {
      return dayjs(src, 'HH:mm:ss').format(format)
    }
  }
}
</script>
